(function(){
  var toggle=document.querySelector('[data-menu-toggle]'),drawer=document.querySelector('[data-menu-drawer]'),backdrop=document.querySelector('[data-menu-backdrop]');
  function setMenu(open){if(!drawer)return;toggle.setAttribute('aria-expanded',String(open));drawer.setAttribute('aria-hidden',String(!open));drawer.inert=!open;drawer.classList.toggle('is-open',open);backdrop.hidden=!open;document.body.classList.toggle('menu-open',open);if(open){drawer.querySelector('button').focus()}else{toggle.focus()}}
  if(toggle&&drawer&&backdrop){toggle.addEventListener('click',function(){setMenu(!drawer.classList.contains('is-open'))});backdrop.addEventListener('click',function(){setMenu(false)});drawer.querySelector('[data-menu-close]').addEventListener('click',function(){setMenu(false)});drawer.addEventListener('click',function(e){if(e.target.closest('a'))setMenu(false)});}
  var modal=document.querySelector('[data-zoom-modal]'),zoomSource;
  function closeZoom(){modal.hidden=true;modal.querySelector('[data-zoom-image]').removeAttribute('src');document.body.style.overflow='';if(zoomSource)zoomSource.focus()}
  document.addEventListener('click',function(e){var link=e.target.closest('[data-zoom-link]');if(link&&modal){e.preventDefault();zoomSource=link;var im=modal.querySelector('[data-zoom-image]');im.src=link.href;im.alt=link.querySelector('img').alt;modal.hidden=false;document.body.style.overflow='hidden';modal.querySelector('button').focus()}else if(modal&&!modal.hidden&&(e.target===modal||e.target.closest('[data-zoom-close]'))){closeZoom()}});
  document.addEventListener('keydown',function(e){var active=modal&&!modal.hidden?modal:drawer&&drawer.classList.contains('is-open')?drawer:null;if(!active)return;if(e.key==='Escape'){if(active===modal)closeZoom();else setMenu(false)}if(e.key==='Tab'){var focusable=Array.from(active.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex="0"]'));var first=focusable[0],last=focusable[focusable.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});
  document.addEventListener('change',function(e){if(!e.target.matches('[data-variant-select]'))return;var option=e.target.options[e.target.selectedIndex],form=document.getElementById(e.target.dataset.form);if(!form||!option.dataset.id)return;form.querySelector('[name="id"]').value=option.dataset.id;var price=document.querySelector('[data-product-price]');if(price)price.textContent=option.dataset.price;var button=form.querySelector('[data-add-button]');if(button){button.disabled=option.dataset.available==='false';button.textContent=button.disabled?button.dataset.unavailableLabel:button.dataset.availableLabel}var url=new URL(window.location.href);url.searchParams.set('variant',option.dataset.id);history.replaceState({},'',url)});
})();

/* Photo navigation is local to each gallery; ordinary taps keep their links. */
(function () {
  function initializeGalleries(root) {
    root.querySelectorAll('[data-ba-gallery]').forEach(function (gallery) {
      if (gallery.dataset.baReady === 'true') return;
      var viewport = gallery.querySelector('[data-ba-viewport]');
      var slides = Array.from(gallery.querySelectorAll('[data-ba-slide]'));
      var controls = gallery.querySelector('[data-ba-controls]');
      if (!viewport || slides.length < 2 || !controls) return;
      gallery.dataset.baReady = 'true';
      var previous = controls.querySelector('[data-ba-previous]');
      var next = controls.querySelector('[data-ba-next]');
      var dots = Array.from(controls.querySelectorAll('[data-ba-dot]'));
      var status = controls.querySelector('[data-ba-status]');
      var index = 0, pointer = null, suppressUntil = 0, frame = 0;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function slidePosition(slide) {
        return slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
      }
      function currentIndex() {
        var closest = 0, distance = Infinity;
        slides.forEach(function (slide, i) {
          var delta = Math.abs(slidePosition(slide) - viewport.scrollLeft);
          if (delta < distance) { closest = i; distance = delta; }
        });
        return closest;
      }
      function update() {
        frame = 0;
        index = currentIndex();
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        dots.forEach(function (dot, i) {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', String(i !== index));
          slide.inert = i !== index;
        });
        var message = 'Fotoğraf ' + (index + 1) + ' / ' + slides.length;
        if (status.textContent !== message) status.textContent = message;
      }
      function goTo(target, instant) {
        target = Math.max(0, Math.min(slides.length - 1, target));
        viewport.scrollTo({ left: slidePosition(slides[target]), behavior: instant || reducedMotion.matches ? 'auto' : 'smooth' });
      }
      previous.addEventListener('click', function () { goTo(index - 1); });
      next.addEventListener('click', function () { goTo(index + 1); });
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
      viewport.addEventListener('keydown', function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest('video,iframe,input,select,textarea')) return;
        var target;
        if (event.key === 'ArrowRight') target = index + 1;
        else if (event.key === 'ArrowLeft') target = index - 1;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = slides.length - 1;
        else return;
        event.preventDefault();
        goTo(target);
      });
      viewport.addEventListener('scroll', function () {
        suppressUntil = Date.now() + 250;
        if (!frame) frame = window.requestAnimationFrame(update);
      }, { passive: true });
      viewport.addEventListener('dragstart', function (event) { if (event.target.closest('img,a')) event.preventDefault(); });
      viewport.addEventListener('pointerdown', function (event) {
        if (!event.isPrimary || event.button !== 0 || event.target.closest('video,iframe,model-viewer,button,input,select')) return;
        pointer = { id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, left: viewport.scrollLeft, startIndex: index, moved: false, dragging: false };
      }, { passive: true });
      viewport.addEventListener('pointermove', function (event) {
        if (!pointer || pointer.id !== event.pointerId) return;
        var dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
        if (Math.abs(dx) > 10 || Math.abs(dy) > 10) pointer.moved = true;
        if (pointer.type !== 'mouse') return;
        if (!pointer.dragging && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          pointer.dragging = true;
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture(event.pointerId);
        }
        if (pointer.dragging) { event.preventDefault(); viewport.scrollLeft = pointer.left - dx; }
      });
      function finishPointer(event) {
        if (!pointer || pointer.id !== event.pointerId) return;
        var gesture = pointer;
        pointer = null;
        if (gesture.moved || Math.abs(viewport.scrollLeft - gesture.left) > 6 || event.type === 'pointercancel') suppressUntil = Date.now() + 400;
        if (gesture.dragging) {
          var dx = event.clientX - gesture.x;
          viewport.classList.remove('is-dragging');
          if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
          goTo(Math.abs(dx) > 35 ? gesture.startIndex + (dx < 0 ? 1 : -1) : gesture.startIndex);
        }
      }
      viewport.addEventListener('pointerup', finishPointer);
      viewport.addEventListener('pointercancel', finishPointer);
      viewport.addEventListener('pointerleave', function (event) { if (pointer && !pointer.dragging) finishPointer(event); });
      viewport.addEventListener('click', function (event) {
        if (Date.now() < suppressUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      controls.hidden = false;
      update();
      if ('ResizeObserver' in window) {
        var width = viewport.clientWidth;
        new ResizeObserver(function () {
          if (viewport.clientWidth === width) return;
          width = viewport.clientWidth;
          goTo(index, true);
        }).observe(viewport);
      }
    });
  }
  initializeGalleries(document);
  document.addEventListener('shopify:section:load', function (event) { initializeGalleries(event.target); });
})();
